import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { PackagesPage } from './_dashboard.inventory.packages'

export const Route = createFileRoute('/_dashboard/inventory/packages/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: PackagesIndexPage,
})

function PackagesIndexPage() {
  return <PackagesPage selectedId={undefined} />
}
